import type { AxiosInstance } from "axios";
import { useAuthStore } from "../AuthStore/useAuthStore";
import { useConfigStore } from "../ConfigStore/useConfigStore";
import { createApi } from "./createApi";
import { isGuestLinkRequest } from "./guestLink";
import { AcceptLanguageRequestInterceptor } from "./Plugin/AcceptHeader/AcceptLanguageRequestInterceptor";
import { contentTypeInterceptor } from "./Plugin/ContentType/contentTypeInterceptor";
import { JwtBearerTokenRequestInterceptor } from "./Plugin/JwtBearerToken/JwtBearerTokenRequestInterceptor";
import { LegacyUrlPrefix } from "./Plugin/Legacy/legacyUrlPrefix";

export const { api, installInterceptor } = createApi({
  enableErrorHandler: true,
  baseURL: requestConfig =>
    requestConfig.url?.includes("oauth/v2/token")
    || requestConfig.url?.includes("oauth/v2/authorize")
      ? `${useConfigStore().config.value?.loginUrl}`
      : `${useConfigStore().config.value?.apiUrl}`,
  interceptors: [
    JwtBearerTokenRequestInterceptor(
      () => useAuthStore().token.value || "",
      config =>
        (config.url?.includes("/oauth/v2/token")
          // A guest link is a credential of its own; the API refuses it together with an access token.
          || isGuestLinkRequest(config)
          // Reading a price-quote share link by its token is public; the trailing slash keeps
          // this scoped to the GET-by-token item route so share-link creation (POST collection)
          // stays authenticated.
          || config.url?.includes("/api/price_quote_share_links/")) ?? false,
    ),
    LegacyUrlPrefix(),
    contentTypeInterceptor({
      excludedRoutes: ["/oauth/v2/token", "/oauth/v2/authorize"],
    }),
    AcceptLanguageRequestInterceptor(),
  ],
});

export default api as AxiosInstance;
